<!--
 * @Author: OP070278 zhang.cheng@opple.com
 * @Date: 2024-07-10 17:34:27
 * @LastEditors: OP070278 zhang.cheng@opple.com
 * @LastEditTime: 2024-10-23 13:46:39
 * @FilePath: /com_light2_web/src/page/login/components/chooseCountry.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="country-box">
    <div class="countryPane">
      <el-select
        v-model="value"
        :title="value"
        popper-class="country-dropdown"
        :placeholder="$t('projectmsg.plhode2')"
        @change="changeCountryValue"
        @visible-change="handleVisibleChange"
      >
         <template #prefix>
          <span v-if="selectedItem">
            <img :src="require(`@static/flags/3x2/${value}.svg`)" alt=""/>
          </span>
        </template>
        <div slot="empty" />


        <div class="country-search-box">
          <!-- 自定义的搜索框 -->
          <el-input
            v-model="inputValue"
            clearable
            @input="handleInput"
          />
          <i class="el-icon-search country-search-icon" />
        </div>

        <!-- 渲染排序后的国家列表 -->
        <el-option
          v-for="item in filteredCountryList"
          :key="item.CountryCode"
          :label="item.CountryName"
          :value="item.CountryCode"
        >
          <template #default>
            <div class="country-left">
              <img :src="require(`@static/flags/3x2/${item.CountryCode}.svg`)" :alt="`flag-${item.CountryCode}`" />
            </div>
            <div class="country-right" :title="item.CountryName">
              {{ item.CountryName }}
            </div>
          </template>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import pinyin from 'pinyin'; // 引入拼音库

export default {
  props: {
    country: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: '',
      inputValue: '' // 绑定搜索框输入
    };
  },
  computed: {
    selectedItem() {
      return this.sortedCountryList.find(option =>  option.CountryCode === this.value);
    },
    // 对国家列表进行排序，中文按照拼音排序，其他语言按照英文名称排序
    sortedCountryList() {
      return this.$store.state.baseData.CountryList.slice().sort((a, b) => {
        const aName = this.getComparableName(a.CountryName);
        const bName = this.getComparableName(b.CountryName);
        return aName.localeCompare(bName,'zh-Hans-CN', { sensitivity: 'base' });
      });
    },
     // 基于用户输入进行过滤后的国家列表
     filteredCountryList() {
      if (!this.inputValue) {
        // 如果没有输入内容，显示全部国家
        return this.sortedCountryList;
      }

      const input = this.inputValue.toLowerCase(); // 将输入的内容转为小写

      // 过滤国家列表：可以匹配国家名或者拼音
      return this.sortedCountryList.filter((item) => {
        // 中文汉字
        const countryName = item.CountryName.toLowerCase();
        // 拼音
        const countryPinyin = this.getPinyin(item.CountryName).toLowerCase();
        //首字母
        const countryInitials = this.getPinyinInitials(item.CountryName).toLowerCase();
        //国家代码
        const countryCode = item.CountryCode.toLowerCase();
        // 英文首字母
        const countryEnInitials = this.getEnglishInitials(item.CountryName).toLowerCase(); // 英文名称首字母



        // 如果输入的内容与国家名或其拼音匹配，则返回该国家
        return (
          countryName.startsWith(input) || countryPinyin.startsWith(input) || countryInitials.startsWith(input) || countryCode === input || countryEnInitials.startsWith(input)
        );
      });
    }
  },
  watch: {
    country: function (e) {
      this.value = e;
    },
    
  },
  mounted() {
    this.value = this.country;
  },
  methods: {
    getUnicodeFlagIcon,
    flagIcon(e){
      return getUnicodeFlagIcon(e) || '';
    },
    // 将中文名称转换为拼音
    getPinyin(name) {
      const chineseRegex = /[\u4e00-\u9fa5]/; // 匹配中文字符的正则表达式
      if (chineseRegex.test(name)) {
        // 使用拼音库将中文转换为拼音
        return pinyin(name, { style: pinyin.STYLE_NORMAL }).join('');
      }
      return name;
    },
    // 获取用于比较的名称，如果是中文，转换为拼音
    getComparableName(name) {
      const chineseRegex = /[\u4e00-\u9fa5]/; // 匹配中文字符的正则表达式
      if (chineseRegex.test(name)) {
        // 如果是中文，使用拼音转换
        return pinyin(name, { style: pinyin.STYLE_NORMAL }).join('');
      }
      // 如果是英文，直接返回
      return name;
    },
    // 将中文名称转换为拼音首字母
    getPinyinInitials(name) {
      const chineseRegex = /[\u4e00-\u9fa5]/; // 匹配中文字符的正则表达式
      if (chineseRegex.test(name)) {
        // 使用拼音库将中文转换为拼音首字母
        return pinyin(name, { style: pinyin.STYLE_FIRST_LETTER }).join(''); // 返回拼音首字母
      }
      return name;
    },
     // 提取英文名称的首字母
     getEnglishInitials(name) {
      if (!name) return ''; // 如果没有英文名称返回空字符串
      return name
        .split(' ') // 将英文名称按空格分割
        .map((word) => word[0]) // 获取每个单词的首字母
        .join(''); // 将首字母组合成一个字符串
    },
    // 搜索过滤方法
    filterCountry(value, option) {
      return option.label.toLowerCase().includes(value.toLowerCase());
    },
    handleVisibleChange(e){
      if(e){
        this.inputValue = ''
      }
    },
    handleInput(value) {
      this.inputValue = value;
    },

    // 处理选择国家事件
    changeCountryValue(e) {
      this.$emit('changeCountryValue', e);
    }
  }
};
</script>

<style lang="scss" scoped>

.countryPane {
  .el-select {
    font-size: 13px;
    color: #434343;
    cursor: pointer;
  }
  
}
</style>
<style lang="scss">
.country-box {
  .el-input--small .el-input__icon{
    line-height: 24px;
  }
}
.country-dropdown{
  .el-scrollbar{
    display: block !important;
  }
  .country-search-box {
    position: absolute;
    padding: 10px 10px 2px 10px;
    top: 0;
    background: #fff;
    z-index: 1;
    width: 100%;
    box-sizing: border-box;
  }
  .country-search-icon {
    position: absolute; 
    left: 18px;
    top: 20px; 
    color: #A7A7A7;
  }
  .popper__arrow{
    display: none;
  }
  .el-select-dropdown__list{
    padding-top: 48px;
  }
  
  .el-input--suffix .el-input__inner{
    padding-left: 30px;
  }
  
  .country-left{
    margin-right: 10px;
    font-size: 14px;
  }
  .country-right {
    white-space: nowrap;        /* 强制不换行 */
    overflow: hidden;           /* 超出部分隐藏 */
    text-overflow: ellipsis;    /* 显示省略号 */
    width: 160px;               /* 设置宽度 */
  }
  .el-select-dropdown__item{
    display: flex;
    padding: 0 10px;
  }
  .el-input__validateIcon{
    display: none;
  }
}

</style>